export default function TrustSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8">
          Cosa Dicono di Noi
        </h2>

        <div className="flex items-center justify-center gap-1 mb-6">
          {[...Array(5)].map((_, i) => (
            <i key={i} className="ri-star-fill text-accent-500 text-xl"></i>
          ))}
        </div>

        <blockquote className="text-lg md:text-xl text-foreground-700 leading-relaxed italic mb-8 font-heading">
          "Itaobuy Spreadsheet ha completamente trasformato il mio modo di fare shopping online. Finalmente ho tutto organizzato in un unico posto e posso confrontare i prezzi in tempo reale. Lo consiglio a chiunque cerchi prodotti di qualita senza perdere ore a cercare."
        </blockquote>

        <div className="flex items-center justify-center gap-3">
          <div className="w-12 h-12 rounded-full bg-primary-200 flex items-center justify-center">
            <span className="font-heading font-bold text-primary-700 text-lg">M</span>
          </div>
          <div className="text-left">
            <p className="text-sm font-semibold text-foreground-900">Marco R.</p>
            <p className="text-xs text-foreground-500">Milano, Italia</p>
          </div>
        </div>

        <div className="flex items-center justify-center gap-4 mt-8">
          <button className="w-10 h-10 rounded-full flex items-center justify-center border border-foreground-200 text-foreground-500 hover:bg-background-50 transition-colors cursor-pointer">
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          <button className="w-10 h-10 rounded-full flex items-center justify-center bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer">
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}